// extracted by mini-css-extract-plugin
export default {"priceRadioGroup":"BaechaWorkDayPopup_priceRadioGroup__ae+AB"};